import { yup } from '@framework/validation/initYup.ts';

/**
 * Schema Yup per la configurazione della competenza
 * di un singolo layer.
 *
 * Segue il pattern intersezione: quando `enabled` e' false
 * i campi dipendenti vengono strippati dal JSON salvato.
 *
 * Quando `enabled` e' true:
 * - `role` e' obbligatorio ('primary' o 'secondary')
 * - `identifyingPropertyName` e' obbligatorio
 * - `secondaryCompetenceTypeId` e' obbligatorio solo se
 *   role === 'secondary'
 */
export const MapLayerCompetenceSchema = yup
  .object({
    /**
     * Abilita la competenza per questo layer.
     * Default: false.
     */
    enabled: yup.boolean().default(false).label('Competenza abilitata'),
    /**
     * Ruolo: 'primary' (max 1 per widget) o 'secondary'.
     * Obbligatorio se enabled.
     */
    role: yup
      .string()
      .oneOf(['primary', 'secondary'])
      .label('Ruolo competenza')
      .when(['enabled'], ([enabled], schema) =>
        enabled ? schema.required() : schema.strip(),
      ),
    /**
     * Nome della proprieta' nelle feature del layer
     * vettoriale che identifica il codice competenza.
     * Obbligatorio se enabled.
     */
    identifyingPropertyName: yup
      .string()
      .label('Nome proprietà identificativa')
      .when(['enabled'], ([enabled], schema) =>
        enabled ? schema.required() : schema.strip(),
      ),
    /**
     * ID del tipo di competenza secondaria.
     * Obbligatorio solo se enabled e role === 'secondary'.
     */
    secondaryCompetenceTypeId: yup
      .string()
      .label('Tipo competenza secondaria')
      .when(['enabled', 'role'], ([enabled, role], schema) =>
        enabled && role === 'secondary' ? schema.required() : schema.strip(),
      ),
    /**
     * Area minima in metri quadri sotto la quale l'intersezione con
     * il layer di competenza viene ignorata. Default: 0.05.
     * Obbligatorio se enabled.
     */
    areaTolerance: yup
      .number()
      .default(0.05)
      .label('Tolleranza (metri quadri minimi)')
      .when(['enabled'], ([enabled], schema) =>
        enabled ? schema.required() : schema.strip(),
      ),
  })
  .addChildrenParentDeps();
